export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      ServiceInfo: {
        ServiceId: 1,
        ServiceName: 'アイラ地域サポート',
        ServiceType: 'コミュニティサポート系',
        CommunityName: 'アイラ地域サポートコミュニティ',
        TenantName: 'アイラ株式会社',
        Status: 1,
        RegisterDt: '2020/12/01 12:00:06',
        UpdateDt: '2020/12/09 05:30:06',
        DeliveryType: [
          {
            PushMastaId: 4,
            PushName: '見守り',
            Priority: 1,
            DeliveryType: 'follow',
            CmsSetting: 0,
            LedSetting: 2,
            LedInterval: 200,
            Status: 1
          },
          {
            PushMastaId: 2,
            PushName: '家族のお知らせ',
            Priority: 2,
            DeliveryType: 'family_info',
            CmsSetting: 1,
            LedSetting: 1,
            LedInterval: null,
            Status: 1
          }
        ]
      }
    }
  }
}